import { ColFormWrapper } from '@hotjar/webapp/features/Registration/common/styles';
import { TwoColumnLayout } from '@hotjar/webapp/features/Activation/OnboardingPage/styles';

export const PersonalisedTestimonialsLayout = ({
  twoColumn = false,
  children,
  dataTestid,
}: {
  twoColumn?: boolean;
  children: React.ReactNode;
  dataTestid?: string;
}): JSX.Element => {
  return twoColumn ? (
    <TwoColumnLayout data-testid={dataTestid}>{children}</TwoColumnLayout>
  ) : (
    <ColFormWrapper data-testid={dataTestid}>{children}</ColFormWrapper>
  );
};
